import { DataGridPro } from "@mui/x-data-grid-pro";
import { Box } from "@mui/material";

function PlaylistDatagrid({ rows }) {
  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    { field: "name", headerName: "Name", flex: 1 },
    { field: "type", headerName: "Type", flex: 0.8 },
    { field: "status", headerName: "Status", flex: 0.8 },
    {
      field: "start_time",
      headerName: "Start Time",
      flex: 1,
      renderCell: (params) =>
        params.value ? new Date(params.value).toLocaleString("en-GB") : "N/A",
    },
    {
      field: "end_time",
      headerName: "End Time",
      flex: 1,
      renderCell: (params) =>
        params.value ? new Date(params.value).toLocaleString("en-GB") : "N/A",
    },
  ];

  return (
    <Box sx={{ height: 400, width: "100%" }}>
      <DataGridPro
        rows={rows}
        columns={columns}
        disableRowSelectionOnClick
        getRowHeight={() => "auto"}
        sx={{
          backgroundColor: (theme) => theme.palette.background.paper,
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#f9f9f9",
            fontWeight: "bold",
          },
        }}
      />
    </Box>
  );
}

export default PlaylistDatagrid;
